import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from '../../design-system/settings/variables/Colors';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';
import { SESEventLog } from 'admin/pages/SESLogs/eventUtils';

const StyledDiv = styled.div<{ selected: boolean; onClick?: () => unknown }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACERS.small};
  height: 24px;
  ${({ onClick }) => (onClick ? 'cursor: pointer;' : '')}
  .dot-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .dot {
      z-index: 1;
      border-radius: 50px;
      width: 7px;
      height: 7px;
      background-color: ${COLORS.success};
    }
    &.failed {
      .dot {
        background-color: ${COLORS.critical};
      }
      .line {
        display: none;
      }
    }
    .line {
      width: 1px;
      background-color: ${COLORS.greyLight};
      height: 32px;
      position: absolute;
      top: 8px;
    }
  }
  .text-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${SPACERS.tiny};
    ${({ selected }) =>
      selected ? `border-right: 5px solid ${COLORS.ctaPrimary};` : ''}
  }
  .icon-container {
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;
    background-color: ${COLORS.greyLight};
    border-radius: 50px;
    &.failed {
      background-color: ${COLORS.criticalBackground};
      color: ${COLORS.critical};
    }
  }
`;

export interface LogTimelineEventProps {
  id: string;
  originalEvent: SESEventLog;
  isSuccess: boolean;
  eventName: string;
  timestamp: string;
  icon: IconDefinition | IconProp;
}

const LogTimelineEvent: React.FC<LogTimelineEventProps & {
  selected: boolean;
  isLastEvent: boolean;
  onClick?: () => unknown;
}> = ({
  icon,
  isSuccess,
  selected,
  isLastEvent,
  eventName,
  timestamp,
  onClick,
}) => {
  const t = new Date(timestamp).toUTC({
    doubleBack: true,
    showWithOffset: true,
  });
  return (
    <StyledDiv onClick={onClick} selected={selected}>
      <div className="progress">
        <div className={`dot-wrapper ${isSuccess ? '' : 'failed'}`}>
          <div className="dot"></div>
          {!isLastEvent && <div className="line"></div>}
        </div>
      </div>
      <div className="text-wrapper">
        <div className={`icon-container ${isSuccess ? '' : 'failed'}`}>
          <FontAwesomeIcon icon={icon} />
        </div>
        <TrueImpactText variant="body-small-bold" className="nav-item-name">
          {eventName}
        </TrueImpactText>
        <TrueImpactText
          variant="body-small"
          color="greyDark"
          className="nav-item-name"
        >
          {t}
        </TrueImpactText>
      </div>
    </StyledDiv>
  );
};

export default LogTimelineEvent;
